// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1KWTs","productName":"Table_productName__1rAMg"};